<template>
  <Output
    :kokubanDataList="kokubanDataList"
    :currentConstruction="currentConstruction"
    @reloadKokubanDataList="reloadKokubanDataList($event)" />
</template>

<script>
import store from '../../../store'

// 黒板リストの初期化
const initKokubanDataList = async (cloudConstructionId) => {
  const args = {
    cloud_construction_id: cloudConstructionId
  };
  const apiResult = await store.dispatch('api/getKokubanDataList', args)
  if (store.getters['api/apiError']) {
    return false;
  }
  const aws_args = {
    cloud_construction_id: cloudConstructionId,
    kokubandata_list: apiResult
  }
  await store.dispatch('aws/kokubanDataListOf', aws_args)
  if (store.getters['api/apiError']) {
    return false;
  }
  store.dispatch('api/getCloudConstructionInfo', args)
  return true;
}

export default {
  name: 'KokubanOutput',
  components: {
    Output: () => import('../../../components/cloud/CreKokuban/ConstructionFolder/Output.vue')
  },
  props: {
    currentConstruction: Object
  },
  computed: {
    kokubanDataList() {
      // awsからの取得結果を返す
      return this.$store.getters['aws/result/curKokubanDataList'];
    }
  },
  beforeRouteEnter(to, from, next) {
    // 黒板リスト取得
    initKokubanDataList(to.params.cloudConstructionId).then(inintResult => {
      if(!inintResult){
        next(false);
        return;
      }
      next();
    })
  },
  methods: {
    reloadKokubanDataList({ cloudConstructionId, done }){
      initKokubanDataList(cloudConstructionId).then(() => {
        done();
      })
    }
  }
}
</script>

<style scoped>
</style>